import script from "./DropdownProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./DropdownProduct.vue?vue&type=script&setup=true&lang=ts"

import "./DropdownProduct.vue?vue&type=style&index=0&id=581c952e&scoped=true&lang=scss"

import exportComponent from "/builds/ext/ERCO/productdata-archive-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-581c952e"]])

export default __exports__